var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.0234375 13.7012C4.2041 18.2246 8.25762 22.2969 12.1541 27.4473C16.3904 19.0215 20.7264 10.5664 27.8807 1.40999L25.9529 0.526978C19.9119 6.93362 15.2186 12.9981 11.1404 20.2051C8.30449 17.6504 3.72129 14.0352 0.922852 12.1778L0.0234375 13.7012Z",
    fill: "#F37021"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.fc16c539447b0b3fcd84549e75498bb4.svg";
export { ForwardRef as ReactComponent };